import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useProgressItems } from '../contexts/ProgressContext';

export const useUploadRefreshWarning = () => {
    const { t } = useTranslation();
    const { progressItems } = useProgressItems();

    useEffect(() => {
        const handleBeforeUnload = (e: BeforeUnloadEvent) => {
            if (!progressItems || typeof progressItems !== 'object') {
                return;
            }

            const activeUploads = Object.values(progressItems).filter(
                item => item?.type === 'upload' && 
                       (item?.status === 'uploading' || 
                        item?.status === 'initiated' || 
                        item?.status === 'processing' ||
                        item?.status === 'resuming')
            );

            if (activeUploads.length > 0) {
                e.preventDefault();
                const message = t("Upload will be stopped if you refresh the page, are you sure?");
                e.returnValue = message;
                return message;
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [progressItems, t]);
};
